<template>
  <span class="percentage-change" >
    <font-awesome-icon class="green" icon="arrow-up" v-if="positive" />
    <font-awesome-icon class="red" icon="arrow-down" v-else />
    <span :class="{ 'green': positive, 'red': !positive }">{{percentageChangeAbs}}
      <span v-if="percent">%</span>
      <span v-if="message"> {{message}}</span>
    </span>
  </span>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
export default {
  name: 'percentage-change',
  props: {
    // Todo: change back to integer once number formatting is sorted
    change: Number,
    percent: Boolean,
    message: String,
  },
  computed: {
  },
  data() {
    return {
      percentageChangeAbs: Math.abs(this.change),
      positive: this.change >= 0,
    };
  },
  components: { 'font-awesome-icon': FontAwesomeIcon }
};
</script>
<style lang="scss">
.percentage-change {
  line-height: normal;
  display: inline-block;
  .svg-inline--fa {
    margin-right: 3px;
    margin-top: 2px;
    height:13px;
    width:13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/percentage-change.vue